import React, { ReactElement, forwardRef, useContext } from 'react';
import clsx from 'clsx';
import { AccordionContext } from './accordion-context';

interface AccordionDetailsProps {
  children?: ReactElement | string;
  className?: string;
}

const AccordionDetails = forwardRef<HTMLDivElement, AccordionDetailsProps>(function AccordionDetails(
  { children, className },
  ref
) {
  const { type } = useContext(AccordionContext);

  return (
    <div
      className={clsx(
        'c-accordion__content',
        type === 'gray' && 'c-accordion__content--addPaddingTop',
        className && className
      )}
      ref={ref}
    >
      {children}
    </div>
  );
});

export { AccordionDetails };
